import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Heading } from '@/components/ui/heading';
import { Skeleton } from '@/components/ui/skeleton';
import { trpc } from '@/lib/trpc';
import { activeOrganizationWithStorageAtom } from '@/stores/workspaceStore';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';
import { useAtom } from 'jotai';
import { WorkspaceForm } from '@/pages/workspaces/components/WorkspaceForm';

export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/edit')({
  component: EditWorkspacePage
})

function EditWorkspacePage() {
  const { workspaceId } = useParams({ from: '/(protected)/workspaces/$workspaceId/edit' });
  const navigate = useNavigate();
  const [activeOrganization] = useAtom(activeOrganizationWithStorageAtom)

  // Get workspace details
  const { data: workspaceData, isLoading, error } = useQuery(
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    trpc.workspaces.getWorkspaceById.queryOptions({ id: workspaceId, organizationId: activeOrganization?.id! })
  );

  // Navigate back to workspace details on success
  const handleSuccess = () => {
    // navigate({ to: '/workspaces/$workspaceId', params: { workspaceId } });
  };

  if (isLoading) {
    return <WorkspaceFormSkeleton />;
  }

  if (error || !workspaceData) {
    return (
      <div className="p-4 bg-destructive/10 text-destructive rounded-md">
        Error loading workspace: {error?.message || 'Workspace not found'}
      </div>
    );
  }



  return (
    <div className="max-w-2xl mx-auto">
      <Heading as="h2" className="mb-6">Edit Workspace</Heading>
      
      <Card>
        <CardHeader>
          <CardTitle>Edit Workspace Details</CardTitle>
          <CardDescription>
            Update the information for your workspace.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <WorkspaceForm 
            defaultValues={workspaceData}
            workspaceId={workspaceId}
            isEditMode={true}
            onSuccess={handleSuccess}
          />
        </CardContent>
      </Card>
    </div>
  );
}

function WorkspaceFormSkeleton() {
  return (
    <div className="max-w-2xl mx-auto">
      <Skeleton className="h-10 w-40 mb-6" />
      
      <Card>
        <CardHeader>
          <Skeleton className="h-6 w-40 mb-2" />
          <Skeleton className="h-4 w-full" />
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-2">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-4 w-3/4" />
          </div>
          
          <div className="space-y-2">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-32 w-full" />
            <div className="space-y-1">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-5/6" />
              <Skeleton className="h-4 w-4/6" />
            </div>
          </div>
          
          <div className="flex justify-end">
            <Skeleton className="h-10 w-32" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
} 